import superagent from 'superagent'

export const gearDropMarkersSet = markers => ({
  type: 'GEAR_DROP_MARKERS_SET',
  payload: markers,
})

export const showGearDropMarkers = () => ({
  type: 'GEAR_DROP_SHOW',
})

export const hideGearDropMarkers = () => ({
  type: 'GEAR_DROP_HIDE',
})

export const fetchGearDropMarkers = () => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI_2__}/GearDropMarker/GetAll`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          console.error('fetchGearDropMarkers error:', err)
          return reject(err)
        }
        dispatch(gearDropMarkersSet(res.body || []))
        resolve(res.body)
      })
  })
}
